import React from 'react';
import CardWrapper from './CardWrapper';
import { Link } from 'react-router-dom';
import constants from '../Constants';
import moment from 'moment';

const HistoryReview = (props) => {

    const { vehicles } = props;

    function convertDate(date) {
        console.log(date,'is the date we are converting');
        if(date === 'Invalid date'){
            return moment().format('MM/DD/YYYY');
        }
        return moment(date, 'YYYY,MM,DD').format('MM/DD/YYYY');
    }

    function setPolicyStartDate(date) {
        if (date) {
            return convertDate(date);
        }
        else {
            return moment().format('MM/DD/YYYY');
        }
    }

    const {
        policyStatus,
        carrier,
        howlongcontinuouslyinsured,
        hasPossibleLapse,
        coverages,
        lastReportedTermExpirationDate,
        newpolicystartdate
    } = props.defaultData;

    props.defaultData.lastReportedTermExpirationDate = convertDate(lastReportedTermExpirationDate);
    props.defaultData.newpolicystartdate = setPolicyStartDate(newpolicystartdate);

    return (
        <CardWrapper>
            <div>
                <h3>
                    <i className="fa fa-history" aria-hidden="true" />
                    {` Coverages`}
                    <Link
                        to={`history`}
                        className="btn btn-secondary history-btn">
                        <i className={constants.icons.edit} />
                        {` Edit`}
                    </Link>
                </h3>

                <div className="summary-list-item">
                    <p className="item-data">
                        <b>Policy Level</b>
                    </p>
                    <div>
                        <ul className="driverInformation">
                            <li>
                                <b>Liability</b>
                                <p>$100k/$300k/$50k</p>
                            </li>
                            <li>
                                <b>Personal Injury Protection</b>
                                <p>$15,000 </p>
                            </li>
                            <li>
                                <b>Uninsured Motorist &amp; Underinsured Motorist</b>
                                <p>$100k/$300k</p>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="summary-list-item">
                    <p className="item-data">
                        <b>Vehicle Level</b>
                    </p>
                    {vehicles.map((element, index) => {
                        const {make, model, year} = element;
                        return (
                            <div key={index}>
                                <p>
                                    <b>{`${make}/${model}/${year}`}</b>
                                </p>
                                <div>
                                    <ul className="driverInformation">
                                        <li>
                                            <b>Collision &amp; Comprehensive</b>
                                            <p>less $500 deductible</p>
                                        </li>

                                        <li>
                                            <b>Collision &amp; Comprehensive Loss Settlement</b>
                                            <p>Actual Cash Value</p>
                                        </li>

                                        <li>
                                            <b>
                                                Rental
                                </b>
                                            <p>$50/occ</p>
                                        </li>

                                        <li>
                                            <b>Towing/Labor</b>

                                            <p>$30/$900</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {/*
                <div className="summary-list-item">
                    <p className="item-data">
                        <b>Current Carrier </b>
                    </p>
                    <p>
                        {carrier.name}
                    </p>
                </div>
                 */}
                {/*
                <div className="summary-list-item">
                    <p className="item-data">
                        <b>Policy Status </b>
                    </p>
                    <p>
                        {policyStatus}
                    </p>
                </div>
                 */}
                <div className="summary-list-item">
                    <p className="item-data">
                        <b>Current Policy Expiration Date </b>
                    </p>
                    <p>
                        {lastReportedTermExpirationDate}
                    </p>
                </div>
                <div className="summary-list-item">
                    <p className="item-data">
                        <b>Policy Start Date </b>
                    </p>
                    <p>
                        {newpolicystartdate}
                    </p>
                </div>
            </div>
        </CardWrapper>
    )
}

export default HistoryReview;





// WEBPACK FOOTER //
// ./src/QuoteReview/HistoryReview.js